export const NORTH_AMERICAN_PHONE_REGEX = /^1(\d{10})$/i;

export const SHORT_CODE_REGEX = /^(\d+)$/i;
